export const FUND_REPORT_TYPE = {
    FUND_REPORT_REGULAR: "regular",
};
